import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { MonitorType } from 'src/app/core/models/monitor-type.model';
import { User } from 'src/app/core/models/user.model';
import { UserType } from 'src/app/core/models/userType.models';
import { BvTypeService } from 'src/app/core/services/bv-type.service';
import { MonitorTypeService } from 'src/app/core/services/monitor-type.service.';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-board',
  templateUrl: './bvType.component.html',
  styleUrls: ['./bvType.component.scss']
})

/**
 * Dashboard Component
 */
export class BvTypeComponent implements OnInit {
  term: any;
  bvType: any[];

  addEditMode: any;
  bvTypeFormGroup: FormGroup;


  constructor(
    private bvTypeService: BvTypeService, 
    private modalService: NgbModal,
  ) { }

  // bread crumb items
  breadCrumbItems: Array<{}>;

  async ngOnInit(): Promise<void> {
    this.breadCrumbItems = [{ label: 'Fortune' }, { label: 'Bv Type', active: true }];
    await this.refresh();
  }

  async refresh() {
    
    this.bvType = await this.bvTypeService.getAll();
  

    console.log("refresh called", this)
  }

  async onAddNew(modal: unknown) {
    this.addEditMode = "Add";
    this.bvTypeFormGroup = new FormGroup({
      id: new FormControl<string>(''),
      name: new FormControl<string>(''),


    });
    try {
      const results = await this.modalService.open(modal).result;
      console.log('add edit modal returned', {results, saleRepAddEditFormGroup: this.bvTypeFormGroup.value});
      if(results=="Save click") {
        const newPrinterType = await this.bvTypeService.create(this.bvTypeFormGroup.value);
        if(newPrinterType != null) {
          //TODO mark sucesss
        } else {
          //TODO mark failure
        }
      } else {
        //TODO mark cancel
      }
    } catch (error) {
      //TODO mark error
    }
    await this.refresh();
  }

  async onEdit(modal: unknown, original: MonitorType) {
    this.addEditMode = "Edit";
    this.bvTypeFormGroup = new FormGroup({
      id: new FormControl<string>(original.id),
      name: new FormControl<string>(original.name),
      

    });
    try {
      const results = await this.modalService.open(modal).result;
      console.log('add edit modal returned', {results, gameFormGroup: this.bvTypeFormGroup.value});
      if(results=="Save click") {
        const newGame = await this.bvTypeService.update(original.id, this.bvTypeFormGroup.value);
        if(newGame != null) {
          //TODO mark sucesss
        } else {
          //TODO mark failure
        }
      } else {
        //TODO mark cancel
      }
    } catch (error) {
      //TODO mark error
    }
    await this.refresh();
    
  } 

  async onDelete( id: string) {
    await this.bvTypeService.delete(id);
    await this.refresh();     
  } 
}
